const validatePhone = (phone) => {
    const phonePattern = /^\d{10}$/;
    if (phone && !phonePattern.test(phone)) {
        return "Invalid phone number";
    }
    return false;
};

const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email && !emailPattern.test(email)) {
        return "Invalid email address";
    }
    return false;
};

const validateName = (name) => {
    if (name.length < 4) {
        return "Minimum length of name can be 4";
    } else if (name.length > 30) {
        return "Maximum length of name can be 30";
    } else if (!name.trim()) {
        return "Name cannot be empty.";
    } else if (!/^[a-zA-Z\s]+$/.test(name)) {
        return "Name can only contain letters and spaces";
    } else if (/\s{2,}/.test(name) || /['-]{2,}/.test(name)) {
        return "Name cannot have multiple consecutive spaces or special characters.";
    }
    return false;
};

const validateDob = (dob) => {
    if (!dob) {
        return "Please enter a valid Date of Birth.";
    }

    const [year] = dob.split("-");
    if (year < 1947 || year > 2012) {
        return "Please enter a date of birth between 1947 and 2012.";
    }
    return false;
};

const validateGender = (gender) => {
    if (gender === "Not Selected") {
        return "Gender field is mandatory.";
    }
    return false;
};

export { validateName, validateEmail, validatePhone, validateDob, validateGender };
